import React from 'react';
import { Box, Typography, IconButton, CircularProgress } from '@mui/material';
import { IconX, IconLink, IconExternalLink } from '@tabler/icons-react';

/**
 * Link preview component
 */
const LinkPreview = ({ isLoadingPreview, linkPreview, onRemove }) => {
  if (!isLoadingPreview && !linkPreview) return null;

  return (
    <Box mb={2.5} className="postbox-link-preview-container">
      {isLoadingPreview ? (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          p={3}
          sx={{
            border: '1px solid #e0e0e0',
            borderRadius: '12px',
            bgcolor: '#fafafa'
          }}
        >
          <CircularProgress size={20} sx={{ mr: 1.5 }} />
          <Typography variant="body2" color="textSecondary">
            Loading link preview...
          </Typography>
        </Box>
      ) : (
        <Box
          sx={{
            border: '1px solid #e0e0e0',
            borderRadius: '12px',
            overflow: 'hidden',
            position: 'relative',
            transition: 'all 0.2s ease',
            '&:hover': {
              borderColor: 'rgba(49, 198, 91, 0.5)',
              boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
            }
          }}
        >
          <IconButton
            size="small"
            onClick={onRemove}
            sx={{
              position: 'absolute',
              top: 8,
              right: 8,
              bgcolor: 'white',
              boxShadow: 1,
              zIndex: 2,
              '&:hover': { bgcolor: '#f5f5f5' }
            }}
            aria-label="Remove link preview"
          >
            <IconX size={16} />
          </IconButton>

          <Box display="flex" gap={2} p={1.5}>
            <Box flex={1} minWidth={0}>
              <Box display="flex" alignItems="center" gap={0.75} mb={0.5}>
                <IconLink size={14} style={{ color: '#666' }} />
                <Typography variant="caption" color="textSecondary" noWrap>
                  {linkPreview.domain}
                </Typography>
              </Box>
              <Typography
                variant="subtitle2"
                sx={{
                  fontWeight: 600,
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  mb: 0.5
                }}
              >
                {linkPreview.title}
                <IconExternalLink size={14} style={{ marginLeft: 6, verticalAlign: 'middle', color: '#666' }} />
              </Typography>
              {linkPreview.description && (
                <Typography
                  variant="body2"
                  color="textSecondary"
                  sx={{
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    fontSize: '0.8rem'
                  }}
                >
                  {linkPreview.description}
                </Typography>
              )}
            </Box>
            {linkPreview.image && (
              <Box
                sx={{
                  width: 100,
                  height: 100,
                  flexShrink: 0,
                  borderRadius: '8px',
                  overflow: 'hidden'
                }}
              >
                <img
                  src={linkPreview.image}
                  alt={linkPreview.title}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  onError={(e) => { e.target.style.display = 'none'; }}
                />
              </Box>
            )}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default LinkPreview;
